import { useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '../Modal';
import FormInput from '../FormInput';
import TranslatedText from '../TranslatedText';
import { connect } from '../Network';
import { matomoEvent } from '../matomoTracker';
import { setCredentials } from '../Cookies';
import { getSentence } from '../translations';
import "../../css/signInForm.css"


const SignInForm = ({ open, onClose, onSwitchToSignup, onSwitchToForgotPassword }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [mailErrorMessage, setMailErrorMessage] = useState('');
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
  const [connexionErrorMessage, setConnexionErrorMessage] = useState('');

  const handleInputChange = (field) => (e) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }));
  };

  const emailIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
    </svg>
  );

  const passwordIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
    </svg>
  );

  async function handleSignIn(mail, password) 
  {

    if (mail === ""){
      setMailErrorMessage(getSentence(130));
      setPasswordErrorMessage("")
      setConnexionErrorMessage("");
      return
    }
    else if (password === ""){
      setMailErrorMessage("");
      setConnexionErrorMessage("");
      setPasswordErrorMessage(getSentence(131))
      return
    }

    const response = await connect(mail, password)

    if (response === "connected")
    {
        setMailErrorMessage("");
        setPasswordErrorMessage("")
        setConnexionErrorMessage("");
        setCredentials(mail, password, false);
        matomoEvent('connexion', "web", mail);
        window.history.replaceState(null, "", "/")
    }
    else
    {
      setPasswordErrorMessage("")
      setMailErrorMessage("");
      setConnexionErrorMessage(getSentence(132))
    }
  };

  return (
    <Modal 
      open={open} 
      onClose={onClose} 
      hideCloseButton={true}
      disableBackdrop={true}
      className="modal"
    >
      <Box 
        sx={{ 
          '@keyframes modalFadeIn': {
            '0%': {
              opacity: 0,
              transform: 'translateY(20px)'
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)'
            }
          }
        }}
        class="container"
      >
        <IconButton 
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: 'text.secondary'
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <Typography 
          variant="h4" 
          component="h2" 
          align="center"
          sx={{ 
            mb: 3, 
            fontWeight: 700,
            color: 'primary.main'
          }}
        >
          <TranslatedText textId="signin" />
        </Typography>
        
        <Box 
          sx={{ 
            width: '80px', 
            height: '4px', 
            bgcolor: 'primary.main', 
            mx: 'auto', 
            mb: 4,
            borderRadius: '2px'
          }} 
        />
        
          <FormInput
            type="email"
            id="signin-email"
            name="email"
            placeholder="email"
            value={formData.email}
            onChange={handleInputChange('email')}
            required
            labelTextId="emailLabel"
            icon={emailIcon}
          />

        {/* Show mailErrorMessage message if it exists */}
        {mailErrorMessage && (
          <Typography class="errorMsg">
            {mailErrorMessage}
          </Typography>
        )}


          <FormInput
            type="password"
            id="signin-password"
            name="password"
            placeholder={getSentence(22)}
            value={formData.password}
            onChange={handleInputChange('password')}
            required
            labelTextId="pswLabel"
            icon={passwordIcon}
          />

          {/* Show passwordErrorMessage message if it exists */}
          {passwordErrorMessage && (
          <Typography class="errorMsg">
            {passwordErrorMessage}
          </Typography>
        )}

        {/* Show connexionErrorMessage message if it exists */}
        {connexionErrorMessage && (
          <Typography class="errorMsg" id="connexionErrorMessage">
            {connexionErrorMessage}
          </Typography>
        )}
          
          <Button 
            type="submit" 
            variant="contained" 
            fullWidth
            id="signinButton"
            sx={{ 
              py: 1.5, 
              mt: 3,
              borderRadius: 2,
              fontSize: '1rem',
              fontWeight: 600,
              boxShadow: 3,
              textTransform: 'none',
              transition: 'all 0.3s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 5
              }
            }}
            onClick={()=>handleSignIn(formData.email, formData.password)}
          >
            <TranslatedText textId="signin" />
          </Button>
          
          <Button
            variant="outlined"
            fullWidth
            onClick={(e) => {
              e.preventDefault();
              onSwitchToForgotPassword();
            }}
            sx={{ 
              py: 1.5, 
              mt: 2,
              borderRadius: 2,
              fontSize: '1rem',
              fontWeight: 500,
              textTransform: 'none',
              transition: 'all 0.3s',
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)',
              }
            }}
          >
            <TranslatedText textId="forgotPassword" />
          </Button>
          
          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <TranslatedText textId="noAccount" /> {' '}
              <Typography 
                component="span" 
                variant="body2" 
                sx={{ 
                  color: 'primary.main', 
                  cursor: 'pointer',
                  fontWeight: 500,
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
                onClick={onSwitchToSignup}
              >
                <TranslatedText textId="createAccount" />
              </Typography>
            </Typography>
          </Box>

      </Box>
    </Modal>
  );
};

export default SignInForm; 